import React from "react";
import { Map, TileLayer, Marker } from "react-leaflet";
import L, { divIcon } from "leaflet";

const LocatorMap = props => {
  var state = {
    lat: Number(props.location.split(",")[0]),
    lng: Number(props.location.split(",")[1]),
    zoom: 11
  };
  var tiles =
    "http://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}" +
    (L.Browser.retina ? "@2x" : "") +
    ".png";

  const position = [state.lat, state.lng];
  const icon = divIcon({
    className: "mapmarker",
    iconSize: 30,
    iconAnchor: [15, 33],
    html: '<i class="fas fa-map-marker-alt"></i>'
  });

  return (
    <Map
      scrollWheelZoom={false}
      center={position}
      zoom={state.zoom}
      className="mapsection"
    >
      <TileLayer
        attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy;<a href="https://carto.com/attribution">CARTO</a>.'
        url={tiles}
      />
      <Marker icon={icon} position={position}>
        {/* <Popup>
                  <span>
                      A pretty CSS3 popup. <br /> Easily customizable.
                  </span>
              </Popup> */}
      </Marker>
    </Map>
  );
};

export default LocatorMap;

// export default class LocatorMap extends Component {
//
//   state = {
//     lat: 51.505,
//     lng: -0.09,
//     zoom: 13,
//   }
//   getLocation() {
//       var getLocation = this.props.location;
//       console.log(getLocation)
//   }
//
//
//   render() {
//     const position = [this.state.lat, this.state.lng]
//     return (
//       <Map center={position} zoom={this.state.zoom} className="mapsection">
//           <TileLayer
//               attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy;<a href="https://carto.com/attribution">CARTO</a>.'
//               url='http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png'
//           />
//           <Marker position={position}>
//               {/* <Popup>
//                   <span>
//                       A pretty CSS3 popup. <br /> Easily customizable.
//                   </span>
//               </Popup> */}
//         </Marker>
//       </Map>
//     )
//   }
// }



// WEBPACK FOOTER //
// ./src/components/LeafletMap.js